import { render, staticRenderFns } from "./gradeStandard.vue?vue&type=template&id=586498cf&scoped=true"
import script from "./gradeStandard.vue?vue&type=script&lang=js"
export * from "./gradeStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586498cf",
  null
  
)

export default component.exports